module.exports = __webpack_public_path__ + "static/media/debbiefull.51621d53.png";